import Keycloak from 'keycloak-js';

const envProvider = (process.env.REACT_APP_IDM_PROVIDER || '').toLowerCase();
const hasKeycloakEnv = Boolean(
  process.env.REACT_APP_KEYCLOAK_URL &&
  process.env.REACT_APP_KEYCLOAK_REALM &&
  process.env.REACT_APP_KEYCLOAK_CLIENT_ID
);

// Entra ID aliases — show local login form (auth skipped server-side)
const isEntra = ['entra', 'entra_id', 'azure_ad', 'aad'].includes(envProvider);

// Keycloak is enabled if explicitly set (but not for entra or mock)
export const keycloakEnabled =
  !isEntra && envProvider !== 'mock' && (
    (envProvider === 'keycloak' || envProvider === 'kc') ||
    (!envProvider && hasKeycloakEnv)
  );

export const samlEnabled = envProvider === 'saml' && !isEntra;

export const idmProvider = envProvider || (keycloakEnabled ? 'keycloak' : samlEnabled ? 'saml' : 'local');

export const keycloak = new Keycloak({
  url: process.env.REACT_APP_KEYCLOAK_URL || 'https://auth.fidar.io',
  realm: process.env.REACT_APP_KEYCLOAK_REALM || 'ztai',
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'ztai-dashboard',
});
